import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShift } from '../../context/ShiftContext';
import { useShiftI18n } from '../../i18n/ShiftI18nContext';
import './shift.css';

export default function ShiftLogin() {
  const { login, status, user, needsShiftPick, isOwner } = useShift();
  const { lang, t } = useShiftI18n();
  const nav = useNavigate();
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (status === 'ok' && user) {
      nav(isOwner || !needsShiftPick ? '/shift/home' : '/shift/pick', { replace: true });
    }
  }, [status, user, nav, needsShiftPick, isOwner]);

  useEffect(() => {
    document.title = t('layout.docTitle');
  }, [t, lang]);

  const codeValid = /^\d{4,6}$/.test(code.trim());

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (!codeValid) { setErr(t('login.errCode')); return; }
    setLoading(true);
    try {
      const u = await login(code.trim());
      nav(u?.role === 'owner' ? '/shift/home' : '/shift/pick', { replace: true });
    } catch (e2) {
      const err2 = e2?.response?.data?.error || e2.message;
      setErr(err2 === 'bad_credentials' ? t('login.errBad') : t('login.errFail'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shift-root" data-theme={(() => { try { const th = localStorage.getItem('shift_theme'); return th === 'light' ? 'light' : 'dark'; } catch { return 'dark'; } })()} lang={lang}>
      <div className="shift-phone">
        <form className="shift-login-wrap" onSubmit={submit}>
          <div>
            <div className="shift-login-title">{t('login.title')}</div>
            <div className="shift-login-sub">{t('login.sub')}</div>
          </div>
          <div className="shift-login-field">
            <label>{t('login.codeLabel')}</label>
            <input
              className="shift-login-inp"
              type="tel"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder={t('login.placeholder')}
              autoFocus
            />
          </div>
          {err && <div className="shift-login-err">{err}</div>}
          <button className="shift-login-btn" type="submit" disabled={loading || !codeValid}>
            {loading ? t('login.submitting') : t('login.submit')}
          </button>
        </form>
      </div>
    </div>
  );
}
